var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHongKong(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.652 12.5587C17.2883 14.0711 16.6423 13.7827 16.3252 15.1017C14.4575 14.6526 13.3073 12.7745 13.7563 10.9067C14.2052 9.03896 16.0835 7.88871 17.9513 8.33778C17.3171 10.9757 17.9773 11.206 17.652 12.5587Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8054 13.6793C14.1314 14.4925 13.6574 15.0179 14.8138 15.7271C13.8095 17.3647 11.668 17.8781 10.0304 16.8739C8.39279 15.8697 7.87923 13.728 8.88348 12.0905C11.1964 13.5087 11.6192 12.952 12.8054 13.6793V13.6793Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3735 18.6348C13.5567 17.6249 13.9098 18.238 14.9416 17.3574C16.1888 18.8185 16.0153 21.014 14.5543 22.2612C13.0931 23.5083 10.8976 23.3347 9.65063 21.8737C11.714 20.1123 11.3152 19.538 12.3735 18.6348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9532 20.5775C16.3582 19.1402 17.0504 18.9937 16.5317 17.7404C18.3067 17.0058 20.3412 17.8492 21.0758 19.6241C21.8104 21.3991 20.9669 23.4335 19.1919 24.1681C18.1546 21.6613 17.4853 21.8631 16.9532 20.5775Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2155 16.8218C18.6647 16.9435 18.7391 16.2397 17.3869 16.3459C17.2367 14.4309 18.6676 12.7565 20.5827 12.6062C22.4977 12.4562 24.172 13.887 24.3222 15.8021C21.6174 16.0142 21.6024 16.7131 20.2155 16.8218Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKong);
export default __webpack_public_path__ + "static/media/hong-kong.e7c96970.svg";
export { ForwardRef as ReactComponent };